(function () {
  'use strict';
  var STORE_KEY = 'mlc_quote_pending';
  var TRACK_PREFIX = 'mlc:';
  function pageKind() {
    var p = window.location.pathname || '/';
    if (p === '/') return 'home';
    if (p.indexOf('/products/') === 0) return 'product';
    if (p.indexOf('/collections/') === 0) return 'collection';
    return 'other';
  }
  function publish(eventName, details) {
    if (!window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') return;
    try {
      Shopify.analytics.publish(TRACK_PREFIX + eventName, details || {});
    } catch (err) {}
  }
  function findAnchor(target) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('a[href]');
  }
  function isWhatsapp(a) {
    try {
      var url = new URL(a.getAttribute('href'), window.location.href);
      return ['wa.me', 'api.whatsapp.com', 'web.whatsapp.com', 'www.whatsapp.com'].indexOf(url.hostname.toLowerCase()) !== -1 || url.protocol === 'whatsapp:';
    } catch (err) { return false; }
  }
  function placement(a) {
    var value = a.getAttribute('data-mlc-placement');
    if (value && /^[a-z0-9_-]{1,50}$/i.test(value)) return value;
    if (a.closest('.mlc-site-footer')) return 'footer';
    if (a.closest('.mlc-hero')) return 'hero';
    if (a.closest('.mlc-contact')) return 'contact';
    return pageKind();
  }
  document.addEventListener('click', function (event) {
    var node = event.target;
    var quoteButton = node && node.closest ? node.closest('#open-quoter-modal-btn') : null;
    if (quoteButton) publish('quote_cta_click', {page_type: 'product', placement: 'product_quote_modal'});
    var stockButton = node && node.closest ? node.closest('#div-stock-whatsapp, #div-whatsapp') : null;
    if (stockButton) publish('whatsapp_click', {page_type: 'product', placement: 'product_availability'});
    var a = findAnchor(event.target);
    if (!a) return;
    var base = {page_type: pageKind(), placement: placement(a)};
    if (isWhatsapp(a)) publish('whatsapp_click', base);
    else if (a.hasAttribute('data-mlc-quote') || /cotiz|presupuesto|quote/i.test((a.textContent || '').trim())) publish('quote_cta_click', base);
  }, true);
  document.addEventListener('submit', function (event) {
    var f = event.target;
    if (f && f.id === 'modal-quoter-form') {
      publish('quote_form_attempt', {page_type: 'product', form_id: 'modal-quoter-form'});
      return;
    }
    if (!f || f.id !== 'mlcLeadForm') return;
    if (typeof f.checkValidity === 'function' && !f.checkValidity()) return;
    var params = new URLSearchParams(window.location.search);
    var fields = [['utm_source','mlcUtmSource'],['utm_medium','mlcUtmMedium'],['utm_campaign','mlcUtmCampaign']];
    fields.forEach(function (entry) {
      var el = document.getElementById(entry[1]);
      if (el) el.value = (params.get(entry[0]) || '').slice(0, 90);
    });
    try { window.sessionStorage.setItem(STORE_KEY, '1'); } catch (err) {}
    publish('quote_form_attempt', {page_type: 'home', form_id: 'mlcLeadForm'});
  }, true);
  document.addEventListener('DOMContentLoaded', function () {
    var success = document.querySelector('[data-mlc-quote-success]');
    if (!success) return;
    var pending = false;
    try { pending = window.sessionStorage.getItem(STORE_KEY) === '1'; window.sessionStorage.removeItem(STORE_KEY); } catch (err) {}
    if (pending) publish('quote_request_submitted', {page_type: 'home', form_id: 'mlcLeadForm', source: 'shopify_contact'});
  });
}());